import React, { useState } from "react";
import { useUI } from "../../context/UIContext";
import { serverRestart } from "../../api";

export default function RestartModal({ id, onConfirm }) {
  const { toast, closeModal } = useUI();
  const [reason, setReason] = useState("");
  const [user, setUser] = useState("Administrator");
  const [pw, setPw] = useState("");
  const [busy, setBusy] = useState(false);

  const confirm = async () => {
    if (!pw) return toast("Nhập mật khẩu xác thực", "err");
    if (busy) return;
    setBusy(true);
    try {
      const { ok, data } = await serverRestart(id, {
        user: user || "Administrator",
        password: pw,
        reason,
      });
      if (!ok) {
        setBusy(false);
        return toast(data.message || "Không gửi được lệnh restart", "err");
      }
      closeModal();
      onConfirm(id);
      toast(`${id}: lệnh restart đã gửi tới agent`, "ok");
    } catch {
      setBusy(false);
      toast("Không kết nối được BackendNode", "err");
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
      <div style={{
        background: "var(--amber-soft)",
        border: "1px solid var(--amber)",
        borderRadius: "10px",
        padding: "12px 14px",
        color: "var(--amber)",
        fontSize: "13px",
        lineHeight: "1.5",
        marginBottom: "15px",
      }}>
        ⚠ Lệnh Restart sẽ ngắt kết nối và dừng toàn bộ dịch vụ đang chạy trên máy chủ <strong>{id}</strong>.
      </div>
      
      <div className="field-lbl">Lý do (tuỳ chọn)</div>
      <input
        className="field-inp"
        type="text"
        value={reason}
        placeholder="Cập nhật hệ thống..."
        onChange={(e) => setReason(e.target.value)}
      />
      
      <div className="field-lbl">Tài khoản Windows</div>
      <input
        className="field-inp"
        type="text"
        value={user}
        onChange={(e) => setUser(e.target.value)}
      />
      
      <div className="field-lbl">Mật khẩu xác thực</div>
      <input
        className="field-inp"
        type="password"
        value={pw}
        placeholder="••••••••"
        onChange={(e) => setPw(e.target.value)}
        onKeyDown={(e) => e.key === "Enter" && confirm()}
      />
      
      <div className="modal-footer" style={{ marginTop: "15px" }}>
        <button className="mbtn mbtn-cancel" onClick={closeModal}>
          Huỷ
        </button>
        <button
          className="mbtn restart-confirm-btn"
          onClick={confirm}
          disabled={busy}
          style={{
            background: "var(--amber-soft)",
            border: "1px solid var(--amber)",
            color: "var(--amber)",
          }}
        >
          {busy ? "Đang gửi..." : "↺ Xác nhận Restart"}
        </button>
      </div>
      
      <style>{`
        .restart-confirm-btn:hover:not(:disabled) {
          background: var(--amber) !important;
          color: #000 !important;
        }
      `}</style>
    </div>
  );
}
